import resources from './resources.js'

export const config = {
  interpolation: { escapeValue: false },
  lng: 'en',
  resources,
}

export { resources }
